import { useTranslation } from "react-i18next";
import type { MonthTileData } from "../../lib/dividends-utils";
import { MonthTile } from "./MonthTile";

interface Props {
  year: number;
  upcoming: MonthTileData[];
  past: MonthTileData[];
  onSelectMonth: (month: string) => void;
}

export function MonthGrid({ year, upcoming, past, onSelectMonth }: Props) {
  const { t } = useTranslation();
  const today = new Date();
  const currentMonth = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`;

  const gridClass = "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-2";

  return (
    <div className="flex flex-col gap-4">
      {upcoming.length > 0 && (
        <section>
          <h3 className="text-sm font-bold mb-2">{t("dividends.section.upcoming", { year })}</h3>
          <div className={gridClass}>
            {upcoming.map((m) => (
              <MonthTile
                key={m.month}
                data={m}
                isCurrentMonth={m.month === currentMonth}
                onClick={() => onSelectMonth(m.month)}
              />
            ))}
          </div>
        </section>
      )}
      {past.length > 0 && (
        <section>
          <h3 className="text-sm font-bold mb-2">{t("dividends.section.past", { year })}</h3>
          <div className={gridClass}>
            {past.map((m) => (
              <MonthTile
                key={m.month}
                data={m}
                isCurrentMonth={m.month === currentMonth}
                onClick={() => onSelectMonth(m.month)}
              />
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
